module.exports = __webpack_public_path__ + "static/wp-443d39262867690df940407ebd61ba6d.jpg";